var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.$style.burger,on:{"click":function($event){_vm.isAside ? _vm.$emit('click', $event) : _vm.$emit('update:is-open', !_vm.isOpen)}}},_vm._l((2),function(item){return _c('div',{key:("burger-" + item),class:[
      _vm.$style.item,
      _vm.isWhite && _vm.$style.itemWhite,
      _vm.isSecondary && _vm.$style.itemSecondary,
      _vm.isOpen && _vm.$style.itemClose ]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }